// useSelectedExternalCompany, выбор внешней компании (заказчик)
import { useEffect, useMemo, useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useCompaniesStore, useContractOrdersStore } from 'storeZustand';
import { getCompanies } from 'services';

const useSelectedExternalCompany = () => {
	const [externalCompanies, setExternalCompanies] = useState([]);

	// Все компании
	const [
		setSelectedExternalCompany, // установить компанию оптовика
		clearSelectedExternalCompany
	] = useCompaniesStore(useShallow((state) => [
		state.setSelectedExternalCompany,
		state.clearSelectedExternalCompany
	]));

	// Заказы
	const [
		addOrderFilter,
		orderFilters
	] = useContractOrdersStore(useShallow((state) => [
		state.addOrderFilter,
		state.orderFilters
	]));

	// получение списка внешних компаний
	useEffect(() => {
		const fetchData = async () => {
			const companies = await getCompanies('Внешняя');
			setExternalCompanies(companies);
		}
		fetchData();
	}, []);

	// Сброс внешней компании
	useEffect(() => {
		if (Object.keys(orderFilters).length === 0) {
			clearSelectedExternalCompany();
		}
	}, [orderFilters]);

	// Список внешних компаний для селекта
	const externalCompaniesList = useMemo(() => {
		return externalCompanies?.map((item) => ({
			value: item.id,
			label: item.name,
		})) ?? [];
	}, [externalCompanies]);

	const handleExternalCompanyChange = (value) => {
		setSelectedExternalCompany(value);

		const filters = {
			customer_company_id: value
		};

		addOrderFilter(filters);
	};

	return {
		externalCompaniesList,
		handleExternalCompanyChange,
	};
};

export default useSelectedExternalCompany;